if (!process.env.VUE_APP_IS_WEB) {
  var MediaDB = require("../database/models/Media");

  var fs = require("fs");
  var path = require("path");
  var { COPYFILE_EXCL } = fs.constants;
  var uniqid = require("locutus/php/misc/uniqid"); // require("uniqid");
}

import dates from "@/database/dates";
import strings from "@/database/strings";

import MediaORM from "@/store/orm-axios/models/Media";

import links from "@/links/links";

export default {
  GET_LOGO_IN_BASE64(mediaId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Media POST need to be developed on desktop
      console.warn("WIP: Not available on desktop!");
    } else {
      return new Promise((resolve, reject) => {
        MediaORM.api()
          .GET_LOGO_IN_BASE64(mediaId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Media POST need to be developed on desktop
      console.warn("WIP: Not available on desktop!");
    } else {
      console.log(item);
      return new Promise((resolve, reject) => {
        MediaORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  // NOTE: this is used when generating PDFS FROM DESKTOP
  async POST_MULTIPLE_ON_GENERATE_PDF(mediasToCreate) {
    if (!process.env.VUE_APP_IS_WEB) {
      await Promise.all(
        mediasToCreate.map(async m => {
          var filePath = m.filePath;
          if (filePath.includes(links.PUBLIC_PATH())) {
            filePath = filePath.replace(links.PUBLIC_PATH(), "");
            // public
          }
          // console.log("filepath", filePath);
          var defaultMedia = {
            filename: filePath.replace(/^.*[\\/]/, ""),
            url: filePath,
            file_path: filePath,
            agency_id: Number(localStorage.getItem("agencyId")),
          };
          await new MediaDB(defaultMedia)
            .save()
            .then(res => {
              res.serialize();
              m.media_id = res.id;
            })
            .catch(err => {
              console.error(err);
            });
        })
      );
      return mediasToCreate;
    } else {
      console.error("POST_MULTIPLE_ON_GENERATE_PDF JUST ON DESKTOP!!!");
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MediaDB({ id: item.id })
          .save({ label: item.label }, { isUpdate: true })
          .then(res => {
            var data = res.serialize();
            MediaORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MediaORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var filePath = links.PUBLIC_PATH() + item.file_path;

      return new Promise((resolve, reject) => {
        new MediaDB({ id: item.id })
          .destroy()
          .then(model => {
            fs.unlinkSync(filePath);
            MediaORM.delete(item.id);

            resolve(model);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MediaORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async BULK_DELETE(ids) {
    if (!process.env.VUE_APP_IS_WEB) {
      var errors = [];

      for (const id of ids) {
        var filePath = null;
        await new MediaDB({ id: id })
          .fetch()
          .then(res => {
            filePath = links.PUBLIC_PATH() + res.serialize().file_path;
          })
          .catch(err => {
            console.error(err);
          });
        await new MediaDB({ id: id })
          .destroy()
          .then(model => {
            fs.unlinkSync(filePath);
            MediaORM.delete(id);
          })
          .catch(err => {
            errors.push(err);
          });
      }

      return new Promise((resolve, reject) => {
        if (errors.length == 0) {
          return resolve(ids);
        } else {
          return reject(errors);
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        MediaORM.api()
          .BULK_DELETE(ids)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  // FIXME: might need changes ..
  async POST_MULTIPLE_FOR_RESOLUTION(
    files,
    resolutionType,
    resolutionId,
    duplicateFunctionality = false
  ) {
    // console.log("files", files);
    // console.log("resolutionType", resolutionType);
    // console.log("resolutionId", resolutionId);

    // FIXME: needs changes .. (restrict in online api too)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
    const sizeLimit = 10000000;

    var data = [];
    var errors = [];

    for (const file of files) {
      var error = false;

      if (!duplicateFunctionality) {
        if (!allowedTypes.includes(file.type)) {
          error = true;
          errors.push({
            file: file,
            message: "File type not allowed.",
          });
        }
        if (file.size > sizeLimit) {
          error = true;
          errors.push({
            file: file,
            message: `Too large, max size allowed is ${sizeLimit / 1000}KB.`,
          });
        }
      }

      if (!error) {
        if (!process.env.VUE_APP_IS_WEB) {
          var xFileName = duplicateFunctionality ? file.filename : file.name;
          var xFilePath = duplicateFunctionality ? links.PUBLIC_PATH() + file.file_path : file.path;

          // NOTE: imitate Vich\UploaderBundle\Naming\SmartUniqueNamer
          // Will rename your uploaded files appending a strong unique id to the original name, while applying a transliteration.
          var uniqueFileName = this.getUniqFilename(xFileName);

          var filePath = `/media/${uniqueFileName}`;
          var fileUrl = `/media/${uniqueFileName}`; // ???: ..

          var defaultMedia = {
            filename: uniqueFileName, // xFileName, // ???: ??
            label: file.label ? file.label : this.getFilenameForLabel(xFileName),
            url: fileUrl,
            file_path: filePath,
            resolution_id: resolutionType == "resolution" ? resolutionId : null,
            meeting_has_resolution_id: resolutionType == "meeting_resolution" ? resolutionId : null,
            agency_id: Number(localStorage.getItem("agencyId")),
          };

          try {
            fs.copyFileSync(
              xFilePath,
              path.join(links.MEDIA_PATH(), uniqueFileName),
              COPYFILE_EXCL
            );
          } catch (err) {
            error = true;
            errors.push({
              file: file,
              message: err,
            });
          }

          if (!error) {
            await new MediaDB(defaultMedia)
              .save()
              .then(res => {
                data.push(res.serialize());
              })
              .catch(err => {
                errors.push({
                  file: file,
                  message: err,
                });
              });
          }
        } else {
          var formData = new FormData();
          formData.append("file", file);

          if (resolutionType == "resolution") {
            formData.append("resolution_id", resolutionId);
          } else if (resolutionType == "meeting_resolution") {
            formData.append("meeting_resolution_id", resolutionId);
          }

          formData.append("label", file.label);

          // api call ..
          await MediaORM.api()
            .POST(formData)
            .then(res => {
              data.push(res.response.data);
            })
            .catch(err => {
              errors.push({
                file: file,
                message: err,
              });
            });
        }
      }
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve({
          status: "success",
          message: "The process completed successfully.",
          data: data,
        });
      } else {
        reject({
          status: "error",
          message: "There were some errors in the process.",
          errors: errors,
          data: data,
        });
      }
    });
  },
  // helper functions
  getFilenameForLabel(originalFilename) {
    var fileExtension = path.extname(originalFilename);
    return path.basename(originalFilename, fileExtension);
  },
  getUniqFilename(originalFilename) {
    var fileExtension = path.extname(originalFilename);
    var fileName = path.basename(originalFilename, fileExtension);

    var transliteratedFilename = strings.get_slug(fileName);
    var uniqId = uniqid("-", true);
    uniqId = uniqId.replace(".", "");

    // NOTE: imitate Vich\UploaderBundle\Naming\SmartUniqueNamer
    // Will rename your uploaded files appending a strong uniqueid to the original name, while applying a transliteration.
    return `${transliteratedFilename}${uniqId}${fileExtension}`;
  },
  MEDIA_CREATE_FROM_BASE64(image) {
    return new Promise(resolve => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: need implementation
      } else {
        MediaORM.api()
          .MEDIA_CREATE_FROM_BASE64(image)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            resolve(err);
          });
      }
    });
  },
  MEDIA_CHECK_PDF_FORMAT(files, entityType, entityId, mediaType) {
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("file-" + i, files[i]);
      if (files[i].unique_identifier) {
        formData.append("file-" + i, files[i].unique_identifier);
      }
    }
    if (entityType == "resolution" && entityId) {
      formData.append("resolution_id", entityId);
    } else if (entityType == "meeting_resolution" && entityId) {
      formData.append("meeting_resolution_id", entityId);
    } else if (entityType == "meeting" && entityId) {
      if (mediaType == "additional") formData.append("meeting_id", entityId);
      else if (mediaType == "signed_pv") formData.append("signed_pv_meeting_id", entityId);
      else if (mediaType == "signed_presence")
        formData.append("signed_presence_meeting_id", entityId);
      else if (mediaType == "additional_invitation") {
        formData.append("additional_invitation_media_meeting_id", entityId);
      }
    } else if (entityType == "mandate") {
      if (mediaType == "invitation") {
        formData.append("individual_invitation_mandate_id", entityId);
      } else if (mediaType == "pv") {
        formData.append("individual_pv_mandate_id", entityId);
      }
    } else if (entityType == "buildingOwner") {
      if (mediaType == "lreAgreement") {
        formData.append("building_owner_id", entityId);
      }
    }

    return new Promise(resolve => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: need implementation
      } else {
        MediaORM.api()
          .MEDIA_CHECK_PDF_FORMAT(formData)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            resolve(err);
          });
      }
    });
  },
  MEDIA_UPDATE_PDF_POSITION(orderMediaPosition) {
    return new Promise(resolve => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: need implementation
      } else {
        MediaORM.api()
          .MEDIA_UPDATE_PDF_POSITION(orderMediaPosition)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            resolve(err);
          });
      }
    });
  },
  MEDIA_GET_SIGNATURES(meetingId) {
    return new Promise(resolve => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: need implementation
      } else {
        MediaORM.api()
          .MEDIA_GET_SIGNATURES(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            resolve(err);
          });
      }
    });
  },
};
